"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuListItem = exports.MenuAnchorItem = void 0;
exports.default = MenuItem;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const MenuListItem = exports.MenuListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "MenuListItem",
  class: "pl-m1d21toz"
});
const MenuAnchorItem = exports.MenuAnchorItem = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "MenuAnchorItem",
  class: "pl-mpmh0vj"
});

/**
 * MenuItem component.
 *
 * @param {Object} props React props
 * @param {string} props.text Text
 * @param {string} props.link Link
 * @param {string} props.ariaLabel Aria Label
 * @param {string} props.icon Icon
 * @param {string} props.tabIndex Tab Index
 * @param {string} props.target Target of anchor element
 * @param {node} props.children Children elements
 * @returns {React.ReactElement} Menu
 * @public
 */
function MenuItem({
  text,
  title,
  link,
  href,
  ariaLabel,
  tabIndex,
  icon,
  target = '',
  children
}) {
  title = title || text;
  href = href || link;
  return /*#__PURE__*/_react.default.createElement(MenuListItem, {
    tabIndex: tabIndex,
    "data-cy": "menu-list-item"
  }, (title || icon) && /*#__PURE__*/_react.default.createElement(MenuAnchorItem, {
    href: href,
    "aria-label": ariaLabel,
    target: target
  }, icon && /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  }), title && /*#__PURE__*/_react.default.createElement("span", null, title)), children);
}
MenuItem.propTypes = {
  text: _propTypes.default.string,
  title: _propTypes.default.string,
  link: _propTypes.default.string,
  href: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  icon: _propTypes.default.string,
  tabIndex: _propTypes.default.string,
  target: _propTypes.default.string,
  children: _propTypes.default.node
};